// extracted by mini-css-extract-plugin
export default {"deleteModal":"delete_modal_deleteModal__6wSyl"};